import { useCallback, useState } from 'react';

const ZENDESK_SCRIPT_ID = 'ze-snippet';
const ZENDESK_SCRIPT_SRC = 'https://static.zdassets.com/ekr/snippet.js?key=5092d06f-fc0c-48a6-83cf-385a921d0929';

// Zendesk widget API type
declare global {
    interface Window {
        zE?: (api: string, action: string) => void;
    }
}

const ZendeskWidget = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    const waitForZendeskAndHideButton = useCallback(() => {
        // Check if Zendesk API is available
        const checkZendeskReady = setInterval(() => {
            if (window.zE) {
                clearInterval(checkZendeskReady);
                window.zE('messenger', 'open');
                // Wait a bit for the launcher to appear before hiding our button
                setTimeout(() => {
                    setIsLoaded(true);
                }, 1000);
            }
        }, 100);

        // Cleanup after 10 seconds if Zendesk never loads
        setTimeout(() => {
            clearInterval(checkZendeskReady);
            setIsLoaded(true);
        }, 10000);
    }, []);

    const loadZendeskWidget = useCallback(() => {
        // Check if script already exists and open chat
        if (document.getElementById(ZENDESK_SCRIPT_ID)) {
            waitForZendeskAndHideButton();
            return;
        }

        const script = document.createElement('script');
        script.id = ZENDESK_SCRIPT_ID;
        script.src = ZENDESK_SCRIPT_SRC;
        script.async = true;
        script.dataset.testid = 'ze-snippet';

        // Open chat once script loads
        script.onload = () => {
            waitForZendeskAndHideButton();
        };

        document.body.appendChild(script);

        const style = document.createElement('style');
        style.innerHTML = `
                iframe#launcher {
                    z-index: 9 !important;
                    bottom: 10px !important;
                    right: 10px !important;
                }

                iframe[title="Number of unread messages"] {
                    z-index: 9 !important;
                }
            `;
        document.body.appendChild(style);
    }, [waitForZendeskAndHideButton]);

    if (isLoaded) {
        return null;
    }

    return (
        <button
            aria-label="Open support chat"
            className="fixed right-[10px] bottom-[10px] z-[9] flex h-[64px] w-[64px] cursor-pointer items-center justify-center rounded-full bg-icon-secondary transition-transform"
            onClick={loadZendeskWidget}
            type="button"
        >
            <svg
                height="36px"
                version="1.1"
                viewBox="0 0 24 24"
                width="36px"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10,18 L6,22 L6,18 L10,18 Z M17,6 C19.7614237,6 22,8.23857625 22,11 C22,13.7614237 19.7614237,16 17,16 L17,16 L7,16 C4.23857625,16 2,13.7614237 2,11 C2,8.23857625 4.23857625,6 7,6 L7,6 Z"
                    fill="white"
                    transform="translate(12.000000, 14.000000) scale(-1, 1) translate(-12.000000, -14.000000)"
                />
            </svg>
        </button>
    );
};

export default ZendeskWidget;
